import {combineReducers} from 'redux';
import auth from './auth';
import mybooks from './mybooks';
import mailsent from './mail';
import webbooks from './searchweb';

export default combineReducers({auth, mybooks, mailsent, webbooks});    